import styled from "styled-components";

import { Container as AdminContainer } from "../../../styles/adminPage";
import { md3CardRadius } from "../../../shared/styles/md3Components";
import {
  actionListSubtitle,
  fontSizes,
  lineHeights,
  sectionTitle,
} from "../../../shared/styles/typography";

export const Container = AdminContainer;

export const Main = styled.main`
  box-sizing: border-box;
  width: 100%;
  max-width: 760px;
  margin: 1.6rem auto 4rem;
  padding: 1.6rem;
  flex: 1;
  background: ${({ theme }) => theme.colors.card};
  border-radius: ${({ theme }) => md3CardRadius(theme)}px;
  box-shadow: ${({ theme }) => theme.shadows.md3Level1};
  border: 1px solid ${({ theme }) => theme.colors.border};
  transition: background 0.25s ease, border-color 0.25s ease;

  @media (min-width: 640px) {
    margin: 2.4rem auto 5rem;
    padding: 2.4rem;
  }

  @media (min-width: 900px) {
    margin: 3.2rem auto 5rem;
    padding: 3.2rem;
  }

  fieldset {
    border: none;
    padding: 0;
    margin-bottom: 2.4rem;

    legend {
      ${sectionTitle}
      margin-bottom: 1.6rem;
      padding-bottom: 0.8rem;
      border-bottom: 1px solid ${({ theme }) => theme.colors.border};
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;

      button {
        background: none;
        border: none;
        color: ${({ theme }) => theme.colors.primary};
        font-size: ${fontSizes.sm}px;
        line-height: ${lineHeights.sm}px;
        font-weight: ${({ theme }) => theme.fontWeight.semibold};
        cursor: pointer;
        transition: opacity 0.2s;

        &:hover {
          opacity: 0.85;
        }
      }
    }
  }

  .schedule-item {
    @media (min-width: 700px) {
      display: grid;
      grid-template-columns: 2fr 1fr 1fr;
      column-gap: 1.6rem;
    }
  }

  footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 1.6rem;
    padding-top: 1.6rem;
    border-top: 1px solid ${({ theme }) => theme.colors.border};
    margin-top: 2.4rem;

    p {
      display: flex;
      align-items: center;
      gap: 1rem;
      ${actionListSubtitle}
      margin: 0;
    }
  }
`;
